<template>
    <v-menu
        :ref="name"
        v-model="isActive"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        max-width="290px"
    >
        <template v-slot:activator="{ on }">
            <div class="label text-xs-right" v-if="label">
                <span class="text-xs-right">{{ label }}</span>
            </div>
            <v-text-field
                v-model="result"
                label="Pick a date"
                readonly
                v-on="on"
                outline
                single-line
                class="small darken no-margin"
            ></v-text-field>
        </template>
        <v-date-picker :class="calendarClass" width="290px" v-model="result" no-title scrollable :allowed-dates="allowedDates" :min="minDate" :max="maxDate">
        </v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'Calendar',
    data () {
        return {
            isActive: false
        }
    },
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: false
        },
        value: {
            type: String
        },
        allowedDates: {
            type: Function,
            required: false,
            default: v => v
        },
        minDate: {
            type: String,
            required: false,
            default: undefined,
        },
        maxDate: {
            type: String,
            required: false,
            default: undefined,
        },
        calendarClass: {
            type: String,
            required: false,
            default: null
        }
    },
    watch: {
        result () {
            this.isActive = false
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.label {
    color: $inactive;
    font-size: 14px;
    margin-bottom: 4px;
}
</style>
